import React from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider, CssBaseline, createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ParallaxProvider } from 'react-scroll-parallax';

import screenshot from "../Ziplyne-for-workday/images/ZLWD.svg";
import app from "./images/horsham.svg";
import video from "../Ziplyne-for-workday/images/Ziplyne-on-WorkDay.webm";

import Title from "./title";
import Mountain from "./mountain";
import Slide from "./slide";
import Half from "./half";
import Video from "./video";
import Statistics from "./statistics";
import './main.css';

function Ziplyne_app() {
    // Custom Material UI theme
    const theme = responsiveFontSizes(createMuiTheme({
        typography: {
            fontFamily: 'Lato, Roboto, sans-serif',
            subtitle1: {
                fontWeight: 600,
            }
        },
        palette: {
            background: {
                default: '#fff'
            }
        }
    }));

    const screenIsSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Helmet>
                <title>Ziplyne Application</title>
            </Helmet>
            <ThemeProvider theme={theme}>
                <CssBaseline>
                    <ParallaxProvider>
                        <main>
                            <Title img={app} title={["Does navigating corporate software feel like a grind?", <br />, "Perhaps your Application would benefit from a Ziplyne."]} />
                            <div className="combined-background">
                                <Mountain
                                    small={screenIsSmall}
                                    title={["Is this your Application Experience…", <br />, "Reimagine the Possibilities!"]}
                                />
                                <Half screenshot={screenshot} />
                                <Slide />
                            </div>
                            <Video
                                header={["Ziplyne over Your Application:", <br />, "Easy to Use…Easy to Manage!"]}
                                video={video}
                            />
                            <Statistics />
                        </main>
                    </ParallaxProvider>
                </CssBaseline>
            </ThemeProvider>
        </>
    );
}

export default Ziplyne_app;
